export type SolutionKey =
  | "reviews"
  | "emailApprovals"
  | "roleManagement"
  | "reports"
  | "pim"
  | "automatedElevations"
  | "forms"
  | "employeeOffers"
  | "groupsAdmin"
  | "outOfBand"
  | "siteSelected"
  | "delegations"
  | "workspaces"
  | "userAdmin"
  | "sharePointInventory"
  | "physicalRecords"
  | "physicalRecordsAdmin";

export const solutionRequiredRoles: Record<SolutionKey, string[]> = {
  reviews: ["Reviews"],
  emailApprovals: ["EmailApproval"],
  roleManagement: ["SuperAdmin"],
  reports: ["Reports"],
  pim: ["Pim"],
  automatedElevations: ["PimAutomation", "Pim"],
  forms: ["Forms"],
  employeeOffers: ["EmployeeOffer"],
  groupsAdmin: ["GroupsAdmin"],
  outOfBand: ["OutOfBandComms"],
  siteSelected: ["SuperAdmin"],
  delegations: ["SuperAdmin"],
  workspaces: ["SuperAdmin"],
  userAdmin: ["UserAdmin"],
  sharePointInventory: ["SharePointInventory", "Admin"],
  physicalRecords: ["PhysicalRecordsUser", "PhysicalRecordsAdmin"],
  physicalRecordsAdmin: ["PhysicalRecordsAdmin"],
};

export function hasSolutionAccess(solution: SolutionKey, userRoles: string[]): boolean {
  const normalized = new Set(userRoles.map((r) => r.trim().toLowerCase()));
  if (normalized.has("superadmin")) {
    return true;
  }

  const required = solutionRequiredRoles[solution] ?? [];
  return required.some((r) => normalized.has(r.toLowerCase()));
}
